module.exports = __webpack_public_path__ + "static/media/facebookLogo.190914a8.png";